"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var pick_1 = __importDefault(require("lodash/pick"));
var pickBy_1 = __importDefault(require("lodash/pickBy"));
var react_final_form_1 = require("react-final-form");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var Modal_1 = __importDefault(require("atomicComponents/organisms/Modal"));
var ModalContent_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalContent"));
var ModalFooter_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalFooter"));
var ModalHeader_1 = __importDefault(require("atomicComponents/organisms/Modal/ModalHeader"));
var FieldText_1 = __importDefault(require("components/Form/FieldText"));
var ScrollDiv_1 = __importDefault(require("components/Layout/ScrollDiv"));
var FileInput_1 = __importDefault(require("shared/components/Form/FileInput"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var validators_1 = require("utils/form/validators");
var hook_1 = require("./hook");
var ListOfMatchingServices_1 = __importDefault(require("./ListOfMatchingServices"));
var validation = function (values) {
    var errors = (0, validators_1.requiredFields)(['name', 'website'])(values);
    errors.website = errors.website || (0, validators_1.getUrlError)(values.website);
    errors.niceName = values.niceName && values.name === values.niceName && 'Nice name should never be the same as the name';
    return (0, pickBy_1.default)(errors);
};
var AddNewToolModal = function (props) {
    var _a = __read((0, hook_1.useCreateService)(props.onClose, props.uncuratedService), 5), createService = _a[0], matchingServices = _a[1], resetMatches = _a[2], setUncuratedService = _a[3], uncuratedService = _a[4];
    return ((0, jsx_runtime_1.jsxs)(Modal_1.default, __assign({}, props, { label: "Add new tool" }, { children: [(0, jsx_runtime_1.jsx)(ModalHeader_1.default, { children: (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3 }, { children: uncuratedService ? "Set values for \"".concat(uncuratedService.name, "\"") : 'Add new tool' })) }), (0, jsx_runtime_1.jsx)(ScrollDiv_1.default, __assign({ style: { height: '100%' }, viewStyle: { position: 'inherit' } }, { children: (0, jsx_runtime_1.jsx)(Box_1.default, __assign({ maxHeight: 750 }, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Form, __assign({ onSubmit: createService, validate: validation, initialValues: uncuratedService ? (0, pick_1.default)(uncuratedService, ['name', 'description']) : {} }, { children: function (_a) {
                            var handleSubmit = _a.handleSubmit, submitting = _a.submitting;
                            return ((0, jsx_runtime_1.jsxs)("form", __assign({ onSubmit: handleSubmit }, { children: [(0, jsx_runtime_1.jsxs)(ModalContent_1.default, { children: [matchingServices && (0, jsx_runtime_1.jsx)(ListOfMatchingServices_1.default, __assign({ setUncuratedService: setUncuratedService }, matchingServices)), (0, jsx_runtime_1.jsx)(FieldText_1.default, { name: "name", onChange: resetMatches }), (0, jsx_runtime_1.jsx)(FieldText_1.default, { name: "niceName", onChange: resetMatches }), (0, jsx_runtime_1.jsx)(FieldText_1.default, { name: "website" }), (0, jsx_runtime_1.jsx)(FieldText_1.default, { name: "productDescription", multiline: true, placeholder: "Short Description (on the header)" }), (0, jsx_runtime_1.jsx)(FieldText_1.default, { name: "description", multiline: true, placeholder: 'Long Description (for "About" section)' }), (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { disabled: submitting, name: "logoFileArr", component: FileInput_1.default, label: "Logo", sx: { mb: 2 } })] }), (0, jsx_runtime_1.jsx)(ModalFooter_1.default, { children: (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ type: "submit", disabled: submitting }, { children: uncuratedService ? 'Move uncurated service' : 'Create new service' })) })] })));
                        } })) })) }))] })));
};
exports.default = AddNewToolModal;
